// MOCK: catálogo de partes y resultados de validación/creación
// Activado cuando environment.useMocksInstructivoEmbarque = true
import {
    PartyDetailDto,
    WizardValidationResultDto,
    ShippingInstructionCreatedDto,
} from '@opb-workspace/shared';

export const MOCK_PARTIES_SHIPPERS: PartyDetailDto[] = [
    {
        partyId: 201,
        name: 'Frutexpo SpA',
        shortName: 'Frutexpo',
        fullName: 'Frutexpo SpA',
        address: 'Av. del Mar 1234, Coronel, Chile',
    },
    {
        partyId: 210,
        name: 'Exportaciones Del Sur Ltda.',
        shortName: 'Exp. Del Sur',
        fullName: 'Exportaciones Del Sur Ltda.',
        address: 'Lota 456, Lota, Chile',
    },
    {
        partyId: 218,
        name: 'Agrícola San Lorenzo S.A.',
        shortName: 'San Lorenzo',
        fullName: 'Agrícola San Lorenzo S.A.',
        address: 'Km 12 Ruta 5 Sur, Chillán, Chile',
    },
    {
        partyId: 225,
        name: 'Frutas del Biobío Ltda.',
        shortName: 'Frutas Biobío',
        fullName: 'Frutas del Biobío Ltda.',
        address: 'Los Aromos 890, Concepción, Chile',
    },
    {
        partyId: 233,
        name: 'Coopeumo Export',
        shortName: 'Coopeumo',
        fullName: 'Coopeumo Export',
        address: 'Los Boldos 34, Coltauco, Chile',
    },
];

export const MOCK_PARTIES_CONSIGNEES: PartyDetailDto[] = [
    {
        partyId: 305,
        name: 'Rotterdam Fresh Imports B.V.',
        shortName: 'Rotterdam Fresh',
        fullName: 'Rotterdam Fresh Imports B.V.',
        address: 'Maasvlakte 2, 3199 LS Rotterdam, Netherlands',
    },
    {
        partyId: 312,
        name: 'Hamburg Früchte GmbH',
        shortName: 'Hamburg Früchte',
        fullName: 'Hamburg Früchte GmbH',
        address: 'Fruchtkontor 7, 20459 Hamburg, Germany',
    },
    {
        partyId: 320,
        name: 'Antwerp Fruit Terminal NV',
        shortName: 'Antwerp Fruit',
        fullName: 'Antwerp Fruit Terminal NV',
        address: 'Kaai 420, 2030 Antwerpen, Belgium',
    },
    {
        partyId: 328,
        name: 'Le Havre Fruits S.A.S.',
        shortName: 'Le Havre Fruits',
        fullName: 'Le Havre Fruits S.A.S.',
        address: 'Terminal Fruitière, 76600 Le Havre, France',
    },
    {
        partyId: 335,
        name: 'Felixstowe Cold Chain Ltd.',
        shortName: 'Felixstowe Cold',
        fullName: 'Felixstowe Cold Chain Ltd.',
        address: 'Port Ave. Unit 12, Felixstowe IP11 3SY, UK',
    },
];

export const MOCK_PARTIES_NOTIFIES: PartyDetailDto[] = [
    {
        partyId: 401,
        name: 'Notificaciones Logísticas Europa S.L.',
        shortName: 'Notify Europa',
        fullName: 'Notificaciones Logísticas Europa S.L.',
        address: 'Calle Comercio 5, 28001 Madrid, España',
    },
    {
        partyId: 408,
        name: 'Euro Fresh Notify B.V.',
        shortName: 'Euro Fresh Notify',
        fullName: 'Euro Fresh Notify B.V.',
        address: 'Prins Hendrikkade 102, 1011 AK Amsterdam, Netherlands',
    },
    {
        partyId: 415,
        name: 'Same As Consignee',
        shortName: 'Same As Consignee',
        fullName: 'Same As Consignee',
        address: undefined,
    },
];

export const MOCK_VALIDATE_OK: WizardValidationResultDto = {
    isValid: true,
    errors: [],
    warnings: [
        'El cut-off documental es en menos de 48 horas. Verifique que la documentación esté lista.',
    ],
};

export const MOCK_VALIDATE_ERRORS: WizardValidationResultDto = {
    isValid: false,
    errors: [
        'El campo "Nombre del Consignatario" es obligatorio.',
        'Debe ingresar al menos un ítem de carga con un paquete.',
    ],
    warnings: [],
};

export const MOCK_CREATE_SUCCESS: ShippingInstructionCreatedDto = {
    id: 10047,
    internalReference: 'IE-10047',
    statusId: 4,
    statusName: 'Activo',
    createdAt: new Date().toISOString(),
    emailStatus: 'OK',
};
